import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ModalWinNewLeadComponent} from "./win.component";
import {LeadModule} from "../leads/leads.module";

@NgModule({
    declarations: [ModalWinNewLeadComponent],
    imports: [BrowserModule, LeadModule],
    exports: [ModalWinNewLeadComponent]
})

export class ModalWinNewLeadModule {}


// WEBPACK FOOTER //
// ./src/app/views/modal-win-new-lead/win.module.ts